import { render, staticRenderFns } from "./NewFishComponent.vue?vue&type=template&id=31bab160&"
import script from "./NewFishComponent.vue?vue&type=script&lang=ts&"
export * from "./NewFishComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NewFishComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports